import { render, staticRenderFns } from "./OutStockBox.vue?vue&type=template&id=714083e9"
import script from "./OutStockBox.vue?vue&type=script&lang=js"
export * from "./OutStockBox.vue?vue&type=script&lang=js"
import style0 from "./OutStockBox.vue?vue&type=style&index=0&id=714083e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports